<div class="row">
  <div class="col container-style">
    @if (responseElectronicDocument && responseElectronicDocument.codigo == 200) {
    <!-- Encabezado -->
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
      <div>
        <h5 class="mb-0 ms-0">{{ responseElectronicDocument.descripcionDocumento }}</h5>
        <h6 class="text-muted ms-0 mt-2">Consecutivo: <strong>{{ responseElectronicDocument.consecutivo }}</strong></h6>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <span class="badge fs-6" [class.bg-success]="responseElectronicDocument.esValidoDIAN"
          [class.bg-danger]="!responseElectronicDocument.esValidoDIAN">
          {{ responseElectronicDocument.esValidoDIAN ? 'Válido DIAN' : 'No válido DIAN' }}
        </span>
        <span class="badge fs-6" [class.bg-success]="responseElectronicDocument.resultado === 'Exitoso'"
          [class.bg-warning]="responseElectronicDocument.resultado !== 'Exitoso'"
          [class.text-dark]="responseElectronicDocument.resultado !== 'Exitoso'">
          {{ responseElectronicDocument.descripcionEstatusDocumento || responseElectronicDocument.resultado }}
        </span>
      </div>
    </div>

    <!-- Información general -->
    <div class="card mb-3">
      <div class="card-header fw-bold">Información del documento</div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Tipo de documento</small>
            <span>{{ responseElectronicDocument.tipoDocumento }} - {{ responseElectronicDocument.descripcionDocumento
              }}</span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Fecha del documento</small>
            <span>{{ responseElectronicDocument.fechaDocumento?.slice(0, 19) || '-' }}</span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Fecha de aceptación DIAN</small>
            <span>{{ responseElectronicDocument.fechaAceptacionDIAN?.slice(0, 19) || '-' }}</span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Ambiente</small>
            <span class="badge" [class.bg-primary]="responseElectronicDocument.ambiente == 1"
              [class.bg-secondary]="responseElectronicDocument.ambiente != 1">
              {{ responseElectronicDocument.ambiente == 1 ? 'Producción' : 'Pruebas / Habilitación' }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Mensaje del documento</small>
            <span>{{ responseElectronicDocument.mensajeDocumento || '-' }}</span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Mensaje del servicio</small>
            <span>{{ responseElectronicDocument.mensaje || '-' }}</span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Posee adjuntos</small>
            <span class="badge" [class.bg-success]="responseElectronicDocument.poseeAdjuntos"
              [class.bg-secondary]="!responseElectronicDocument.poseeAdjuntos">
              {{ responseElectronicDocument.poseeAdjuntos ? 'Sí' : 'No' }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Representación gráfica</small>
            <span class="badge" [class.bg-success]="responseElectronicDocument.poseeRepresentacionGrafica"
              [class.bg-secondary]="!responseElectronicDocument.poseeRepresentacionGrafica">
              {{ responseElectronicDocument.poseeRepresentacionGrafica ? 'Sí' : 'No' }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            <small class="text-muted d-block">Aceptación física</small>
            <span class="badge" [class.bg-success]="responseElectronicDocument.aceptacionFisica"
              [class.bg-secondary]="!responseElectronicDocument.aceptacionFisica">
              {{ responseElectronicDocument.aceptacionFisica ? 'Sí' : 'No' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- CUFE -->
    <div class="card mb-3">
      <div class="card-header fw-bold">Identificadores</div>
      <div class="card-body">
        <div class="mb-3">
          <small class="text-muted d-block">{{ 'CUFE' }}</small>
          <p class="d-block text-break">{{ responseElectronicDocument.cufe }}</p>
        </div>
        @if (responseElectronicDocument.cadenaCodigoQR) {
        @let urlValidacionDian = responseElectronicDocument.cadenaCodigoQR.split('\n').pop();
        <div class="mb-3">
          <small class="text-muted d-block">Validación DIAN</small>
          <a class="text-break" [href]="urlValidacionDian" target="_blank" rel="noopener noreferrer">
            {{ urlValidacionDian }}
          </a>
        </div>
        }
      </div>
    </div>

    <!-- Acuse -->
    <div class="card mb-3">
      <div class="card-header fw-bold">Acuse de recibo</div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-12 col-md-6">
            <small class="text-muted d-block">Estatus</small>
            <span>{{ responseElectronicDocument.acuseEstatus == 1 ? 'Acuse realizado' : 'Acuse no realizado' }}</span>
          </div>
          <div class="col-12 col-md-6">
            <small class="text-muted d-block">Comentario</small>
            <span>{{ responseElectronicDocument.acuseComentario }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Historial de entregas -->
    <div class="card">
      <div class="card-header fw-bold">
        Historial de entregas
        <span class="badge bg-secondary ms-1">{{ responseElectronicDocument.historialDeEntregas?.length || 0 }}</span>
      </div>
      <div class="card-body p-0">
        @if (responseElectronicDocument.historialDeEntregas?.length) {
        <div class="table-responsive p-2">
          <table class="table table-sm table-striped align-middle mb-0">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Destinatario(s)</th>
                <th>Mensaje</th>
                <th>Recepción</th>
                <th>Lectura</th>
              </tr>
            </thead>
            <tbody>
              @for (entrega of responseElectronicDocument.historialDeEntregas; track $index) {
              <tr>
                <td class="text-nowrap">{{ entrega.entregaFecha?.slice(0, 19) || '-' }}</td>
                <td>
                  <span class="badge" [class.bg-success]="entrega.entregaEstatus == 200"
                    [class.bg-danger]="entrega.entregaEstatus != 200">
                    {{ entrega.entregaEstatus }} - {{ entrega.entregaEstatusDescripcion }}
                  </span>
                </td>
                <td>
                  @for (correo of entrega.email; track $index) {
                  <div class="text-break">{{ correo }}</div>
                  }
                  @if (entrega.telefono) {
                  <div>{{ entrega.telefono }}</div>
                  }
                </td>
                <td>{{ entrega.mensajePersonalizado || '-' }}</td>
                <td>
                  @if (entrega.recepcionEmailFecha) {
                  {{ entrega.recepcionEmailFecha.slice(0, 19) }}
                  } @else {
                  <span class="text-muted">Sin confirmar</span>
                  }
                </td>
                <td>
                  @if (entrega.leidoFecha || entrega.LeidoFecha) {
                  {{ (entrega.leidoFecha || entrega.LeidoFecha).slice(0, 19) }}
                  } @else {
                  <span class="text-muted">No leído</span>
                  }
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @else {
        <p class="text-center text-muted my-3">Sin entregas registradas.</p>
        }
      </div>
    </div>

    <!-- Estatus del Documento en RADIAN -->
    <div class="card mt-3">
      <div class="card-header fw-bold">
        Estatus del Documento en RADIAN
        <span class="badge bg-secondary ms-1">{{ responseElectronicDocument.eventosResult?.length || 0 }}</span>
      </div>
      <div class="card-body p-0">
        @if (responseElectronicDocument.eventosResult?.length) {
        <div class="table-responsive p-2">
          <table class="table table-sm table-striped align-middle mb-0">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Evento</th>
                <th>Emisor</th>
                <th>Receptor</th>
                <th>CUDE</th>
              </tr>
            </thead>
            <tbody>
              @for (evento of responseElectronicDocument.eventosResult; track $index) {
              <tr>
                <td class="text-nowrap">{{ evento.fechaEvento?.replace('T', ' ').slice(0, 19) || '-' }}</td>
                <td>
                  <span class="badge bg-primary me-1">{{ evento.codigoEvento }}</span>
                  {{ evento.descripcionEvento }}
                  @if (evento.numeroEvento) {
                  <small class="text-muted d-block">{{ evento.numeroEvento }}</small>
                  }
                </td>
                <td>
                  {{ evento.emisorEvento || '-' }}
                  @if (evento.numeroIdentificacionEmisor) {
                  <small class="text-muted d-block">{{ evento.numeroIdentificacionEmisor }}</small>
                  }
                </td>
                <td>
                  {{ evento.receptorEvento || '-' }}
                  @if (evento.tipoIdentificacionReceptor) {
                  <small class="text-muted d-block">{{ evento.tipoIdentificacionReceptor }}</small>
                  }
                </td>
                <td style="max-width: 220px;">
                  <code class="d-block text-break small">{{ evento.cudeEvento || '-' }}</code>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @else {
        <p class="text-center text-muted my-3">Sin eventos registrados en RADIAN.</p>
        }
      </div>
    </div>
    } @else if (responseElectronicDocument && responseElectronicDocument.codigo == 102) {
    <div class="d-flex flex-column align-items-center text-center py-5 px-3 gap-2">
      <span class="d-flex align-items-center justify-content-center rounded-circle bg-warning-subtle text-warning"
        style="width: 64px; height: 64px;">
        <i class="pi pi-exclamation-triangle" style="font-size: 1.75rem;"></i>
      </span>
      <h6 class="mb-0 mt-2">Sin información disponible</h6>
      <p class="text-muted mb-0">No se encontró información del documento electrónico.</p>
    </div>
    } @else {
    <div class="d-flex flex-column align-items-center text-center py-5 px-3 gap-2" role="status" aria-live="polite">
      <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" aria-hidden="true"></div>
      <h6 class="mb-0 mt-2">Consultando información</h6>
      <p class="text-muted mb-0">Estamos consultando el documento electrónico, por favor espera un momento.</p>
    </div>
    }
  </div>
</div>
<div class="row">
  <div class="col mt-3 d-flex justify-content-end gap-2">
    <app-custom-button [title]="'Salir'" [label]="'Salir'" [variant]="undefined" [severity]="'danger'"
      (onClick)="close()"></app-custom-button>
  </div>
</div>